import { Typography, styled } from "@mui/material";

import { Form as UnstyledForm } from "./form";

export const Form = styled(UnstyledForm)({
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
}) as typeof UnstyledForm;

export const Description = styled(Typography)(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.grey[300]}`,
  margin: theme.spacing(0, 3),
  padding: theme.spacing(3, 0),
}));
